module.exports = __webpack_public_path__ + "assets/img/gar8-1.efdcf231.jpg";